import { BooleanField, Datagrid, DateField, EditButton, ReferenceManyField, ShowContextProvider, ShowView, Tab, TabbedShowLayout, TextField, useShowController } from 'react-admin';
import ContextTitle from '../../Components/ContextTitle';

const UsersShow = () => {
  const controllerProps = useShowController();
  return (
    <ShowContextProvider value={controllerProps}>
      <ShowView title={<ContextTitle context="fullName" />}>
        <TabbedShowLayout>
          <Tab label="Summary">
            <TextField source="id" />
            <TextField source="uuid" />
            <TextField source="fullName" />
            <TextField source="taxPayerId" />
            <BooleanField source="active" />
            <TextField source="language" />
            <TextField source="sourcePlatform" />
            <TextField source="sourceType" />
            <DateField source="birthDate" />
            <DateField source="createdAt" />
            <DateField source="updatedAt" />
          </Tab>
          <Tab label="Owners">
            <ReferenceManyField label="Owners" reference="profiles" target="company" sort={{ field: 'created_at', order: 'DESC' }} filter={{ role: 'employer' }}>
              <Datagrid>
                <DateField source="created_at" />
                <TextField source="fullName" />
                <TextField source="role" />
                <EditButton />
              </Datagrid>
            </ReferenceManyField>
          </Tab>
        </TabbedShowLayout>
      </ShowView>
    </ShowContextProvider>
  );
};

export default UsersShow;
